module.exports = __webpack_public_path__ + "static/crash-7d57a11887e2f9af438cdad1ab7bc7d5.png";